import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { payPlanMobx, payChannelMobx } from '@mobxStore'
import { find } from '@dt/fe-utils/dist/lodash'
import { stripeConfigG } from '@ctrls/third'
import AppleSimpleItem from './SimpleItem'

const MethodItem = ({ selected, method, onChange }: { selected?: boolean; method?: any; onChange?: () => void }) => {
  const amount = method?.amount || payPlanMobx.externalMethod?.amount
  const [isShow, setIsShow] = useState(false)

  const handleChange = () => {
    if (onChange) {
      onChange()
    } else {
      payPlanMobx.changeExternalPayMethod('ApplePayWeb')
    }
  }

  useEffect(() => {
    const method = find(
      payChannelMobx.availableExternalMethods,
      (x) => x === 'ApplePayWeb'
    )
    if (method) {
      const channel = payChannelMobx.methodChannel[method]
      if (channel.channelType === 'StripeApplePay') {
        stripeConfigG.init(() => {
          setIsShow(true)
        })
      } else {
        setIsShow(true)
      }
    }
    return () => {
      stripeConfigG.remove()
    }
  }, [payChannelMobx.availableExternalMethods])

  return (
    setIsShow && <AppleSimpleItem selected={selected} amount={amount} onChange={handleChange} />
  )
}

export default observer(MethodItem)
